import styled from 'styled-components';

export const SideBySide = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: ${({ theme }) => theme.spacing(20)};
  max-width: ${({ theme }) => theme.spacing(544)};
`;
